module.exports = __webpack_public_path__ + "static/media/Moving Hours icon (1).81efd530.svg";